import * as React from "react";
import "./style.scss";
import { observer } from "mobx-react";

// Mobx
import HotelStore from "../../../../../stores/HotelStore";

// Components
import TextField from "../../../../../components/TextField";
import MetaTagsList from "./MetaTagsList";
import MetaTagDialog from "./MetaTagDialog";

// Resources
import strings from "../../../../../resources/strings";

interface IProps {
	hotelStore: HotelStore;
}

@observer
export default class HotelMetaTagForm extends React.Component<IProps> {
	public render() {
		const { hotelStore } = this.props;
		return (
			<>
				<h2>{strings.hotel.edit.sections.metaTags}</h2>
				<div className="hotelDataForm">
					<MetaTagDialog
						hotelStore={hotelStore}
					/>
					<MetaTagsList
						hotelStore={hotelStore}
					/>
				</div>
			</>
		);
	}
}
